import axiosClient from "../../common/axios/axiosConfig";
import useQuery from "../../utils/useQuery";

export const addPatientToQueue = async (
  id: string,
  patientId: string,
  name: string,
): Promise<boolean> => {
  try {
    const urlSearchParams = useQuery();
    const telemedicineToken = urlSearchParams.get("token") || "";

    const response = await axiosClient.post(
      `/room/${id}/waiting/${patientId}`,
      { name },
      {
        headers: {
          Authorization: `Bearer ${telemedicineToken}`,
        },
      }
    );
    return response.data.success === true;
  } catch (err) {
    console.error("Erro ao adicionar paciente à fila de espera:", err);
    return false;
  }
};
